import * as utils from './modules/utils';
import 'core-js/fn/symbol/iterator';
import 'core-js/fn/symbol/for';
import 'whatwg-fetch';
import bowser from 'bowser';
import ValidForm from '@pageclip/valid-form';
import Flickity from 'flickity-as-nav-for';
import Accordion from 'accordion/dist/common-js/accordion';
import StickySidebar from 'sticky-sidebar';
import SmoothScroll from 'smooth-scroll';
import Equalizer from 'equalizer';
import noScroll from 'no-scroll';
import { slideDown, slideUp, slideStop, isVisible } from 'slide-anim';

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const moduleRegistration = function(m, u, ui, win, doc){

    m.searchSlide = () => {
        const search = doc.querySelector('.header__search');
        let active = false;
        let visible = false;

        doc.querySelector('.header__button--search').addEventListener('click', () => {
            if( active ){
                return;
            }

            active = true;

            if( visible ){
                slideUp(search).then(() => {
                    active = false;
                    visible = false;
                });
            } else {
                slideDown(search).then(() => {
                    active = false;
                    visible = true;
                });
            }
        });
    };

    // Document loaded class
    m.docLoad = () => {
        u.addClass(document.body, 'is-loaded');
        if(typeof browser !== 'undefined'){
            if(browser.name){
                u.addClass(document.body, bowser.name.replace(/\s+/g, '-').toLowerCase());
            }
            if(bowser.version){
                u.addClass(document.body, bowser.name.replace(/\s+/g, '-').toLowerCase() + '-' + bowser.version.replace(/\s+/g, '-').toLowerCase());
            }
        }
    };

    // Open share links in popup window
    m.sharePopup = () => {
        doc.addEventListener('click', (e) => {
            if( u.hasClass(e.target, 'js-share') ) {
                const url = e.target.getAttribute('href');

                if (url && url.indexOf('http') === 0) {
                    const newWindow = window.open(url, '', 'height=450, width=700');

                    if (window.focus) {
                        newWindow.focus();
                    }

                    e.preventDefault();
                }
            }
        });
    };

    // Set form label active classes to assist styling
    m.formLabels = () => {
        function check (el, force = false){
            const label = u.getSiblings(el, (subject) => { return subject.nodeName.toLocaleLowerCase() === 'label'; });

            if(el.value || force){
                u.addClass(label, 'is-focused');
            } else {
                u.removeClass(label, 'is-focused');
            }
        }

        function checkEvent(e){
            check(e.target, e.type === 'focus');
        }

        for(const field of doc.querySelectorAll('input, textarea')) {
            field.addEventListener('focus', checkEvent);
            field.addEventListener('blur', checkEvent);
            check(field);
        }

        for(const select of doc.querySelectorAll('select')) {
            select.addEventListener('change', checkEvent);
            check(select);
        }
    };

    // initialise google maps
    m.googleMap = () => {
        const maps = document.getElementsByClassName('js-map');

        if (maps.length === 0){
            return false;
        }

        if (win.initMap) {
            win.initMap();
            return false;
        }

        win.initMap = function(){
            for (const map of maps) {
                const lat = map.getAttribute('data-lat'),
                    lng = map.getAttribute('data-lng'),
                    mapOptions = {
                        zoom: 14,
                        scrollwheel: false,
                        mapTypeControl: false,
                        streetViewControl: false,
                        zoomControl: false,
                        draggable: false,
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        center: new google.maps.LatLng(lat,lng)
                    },
                    googleMap = new google.maps.Map(map, mapOptions),
                    marker = new google.maps.Marker({
                        position: mapOptions.center,
                        map: googleMap,
                        draggable: false,
                    });

                marker.setMap(googleMap);
            }
        };

        const src = `//maps.googleapis.com/maps/api/js?v=3&callback=initMap&key=${WP.gmap_key}`,
            protocol = ('https:' === doc.location.protocol ? 'https:' : 'http:'),
            script = doc.createElement('script');

        script.type = 'text/javascript';
        script.async = true;
        script.src = protocol + src;

        doc.getElementsByTagName("head")[0].appendChild(script);
    };

    // Process forms into WP Admin Requests
    m.processForms = () => {

        //Process response from AJAX requests
        function handleResponse(form, message){
            const thanks = doc.createElement('div');
            u.addClass(thanks, 'response');
            thanks.innerHTML = `<p class="response__thanks">${message}</p>`;

            form.parentNode.replaceChild(thanks, form);
        }

        function handleSubmit(e) {
            e.preventDefault();
            const form = e.target;

            // Stop repeated submissions
            if( u.hasClass(form, 'is-loading') ) {
                return false;
            }

            u.addClass(form, 'is-loading');

            // Format request data
            const data = new FormData(form);
            data.append('action', form.getAttribute('action'));
            data.append('security', WP.nonce);

            // Send the request
            let responseStatus,
                message;

            fetch(WP.ajax, {
                method: 'POST',
                body: data
            })
                .then(response => {
                    responseStatus = response.status;
                    return response.json()
                })
                .then(response => {
                    switch (responseStatus) {
                        case 200:
                        case 201:
                        case 202:
                            if(response.data.message){
                                message = response.data.message
                            } else {
                                message = WP.translate.thanks;
                            }
                            break;
                        case 418:
                            message = 'What a regrettably large head you have. I would very much like to hat it. I used to hat The White Queen, you know. Her head was so small.'; // eslint-disable-line max-len
                            break;
                        default:
                            message = WP.translate.error;
                            break
                    }

                    handleResponse(form, message);
                })
                .catch(() => {
                    message = WP.translate.thanks;
                    handleResponse(form, message);
                });
        }

        // Setup form processing
        for(const form of doc.getElementsByClassName('js-process-form')) {
            ValidForm(form, {errorPlacement: 'after'});

            form.addEventListener('submit', handleSubmit);
        }
    };

    // Initialise carousels
    m.carousels = () => {
        for(const carousel of doc.getElementsByClassName('js-carousel')) {
            if( carousel.children.length < 2 ) {
                u.addClass(carousel.querySelector('.banner__slide'), 'is-selected');
                continue;
            }

            const slider = new Flickity(carousel, {
                prevNextButtons: carousel.getAttribute('data-nav') ? carousel.getAttribute('data-nav') : false, // eslint-disable-line max-len
                pageDots: false,
                wrapAround: true,
                cellAlign: 'left',
                autoPlay: carousel.getAttribute('data-auto') ? parseInt(carousel.getAttribute('data-auto'), 0) : false // eslint-disable-line max-le
            });

            const eq = new Equalizer(carousel.querySelectorAll('.flickity-slider > div a'));
            eq.align();

            const navigation = u.getSiblings(carousel, (el) => { return u.hasClass(el, 'banner__navigation') })[0];
            if(navigation){
                let i = 0;
                for(const item of navigation.childNodes) {
                    if(item.nodeType !== 1){
                        continue;
                    }
                    if(i===0){
                        u.addClass(item, 'is-active');
                    }

                    item.setAttribute('data-index', i);

                    item.addEventListener('click', () => {
                        slider.select(item.getAttribute('data-index'));
                    });

                    i++;
                }

                slider.on( 'change', function( index ) {
                    u.removeClass(navigation.querySelectorAll('.is-active'), 'is-active');
                    u.addClass(navigation.children[index], 'is-active');
                });
            }
        }
    };

    // Initialise accordions
    m.accordions = () => {
        for(const el of doc.getElementsByClassName('js-accordion')) {
            new Accordion(el);

            if( el.getAttribute('data-open') === 'true' ){
                setTimeout(() => {
                    for(const child of el.children) {
                        u.trigger('click', child.querySelector('.woocommerce-tabs__trigger'));
                    }
                }, 100);
            }
        }
    };

    //Initialise smooth scroll links
    m.smoothScroll = () => {
        new SmoothScroll('a[href*="#"]', {
            offset: 20
        });
    };

    // Initialise sticky sidebar
    m.sidebar = () => {
        if(doc.getElementsByClassName('js-sidebar').length){
            new StickySidebar('.js-sidebar', {
                topSpacing: 20,
                bottomSpacing: 20
            });
        }

        if(doc.getElementsByClassName('woocommerce-MyAccount-navigation').length){
            new StickySidebar('.woocommerce-MyAccount-navigation', {
                topSpacing: 20,
                bottomSpacing: 20,
                minWidth: 700
            });
        }
    };

    // Handle swapping price for products
    m.wooVariationPricing = () => {
        const price = doc.querySelector('.single-product .summary .price');
        let timer;

        if(!price || doc.querySelector('.tile-cart')){
            return;
        }

        const defaultPrice = price.innerHTML;

        function updatePrice(){
            timer = setTimeout(() => {
                const newPrice = doc.querySelector('.single_variation .woocommerce-variation-price');

                if(doc.querySelector('.woocommerce-variation-add-to-cart') && u.hasClass(doc.querySelector('.woocommerce-variation-add-to-cart'), 'woocommerce-variation-add-to-cart-enabled')){
                    price.innerHTML = newPrice.innerHTML + 'm²<small>(inc VAT)</small>';
                } else {
                    price.innerHTML = defaultPrice;
                }
            }, 100);
        }

        if(defaultPrice.indexOf('From') !== -1){
            updatePrice();

            for(const select of doc.querySelectorAll('.variations select')) {
                select.addEventListener('change', updatePrice);
            }
        }
    };

    //
    m.wooGallery = () => {
        const gallery = doc.querySelector('.woocommerce-product-gallery__wrapper');

        if(!gallery){
            return;
        }

        gallery.innerHTML = `<div class="woocommerce-product-gallery__full">${gallery.innerHTML}</div>
            <div class="woocommerce-product-gallery__navigation">${gallery.innerHTML}</div>`;

        for(const el of gallery.querySelectorAll('a')) {
            el.addEventListener('click', (e) => {
                e.preventDefault();
            });
        }

        const full = new Flickity(doc.querySelector('.woocommerce-product-gallery__full'), {
            prevNextButtons: true,
            pageDots: true,
            wrapAround: true,
            cellAlign: 'left',
            autoPlay: false,
            imagesLoaded: true
        });

        /*
        full.on('change', function(index){
            const img = full.selectedElement.querySelector('img');
            img.width = img.dataset.large_image_width;
            img.height = img.dataset.large_image_height;
            img.src = img.dataset.large_image;
            img.sizes = '';
            img.srcset = '';
        });
        */

        if( doc.getElementsByClassName('woocommerce-product-gallery__navigation')[0].childElementCount > 1 ){
            const navigation = new Flickity(doc.querySelector('.woocommerce-product-gallery__navigation'), {
                prevNextButtons: false,
                pageDots: false,
                wrapAround: false,
                contain: true,
                cellAlign: 'center',
                autoPlay: false,
                imagesLoaded: true,
                asNavFor: '.woocommerce-product-gallery__full'
            });
        } else {
            doc.getElementsByClassName('woocommerce-product-gallery__navigation')[0].style.display = 'none';
        }

        u.trigger('resize', win);

        setTimeout(() => {
            u.trigger('resize', win);
        }, 200);
    };

    m.menu = () => {
        const navigation = doc.querySelector('.navigation'),
            subnav = doc.getElementsByClassName('navigation__sub')[0],
            categories = doc.querySelectorAll('.navigation__category');

        function show(e){
            // Don't run mouseover events on desktop
            if(e.type == 'mouseover' && win.innerWidth <= 1100){
                return;
            }

            // Don't run click events on desktop
            if(e.type == 'click' && win.innerWidth > 1100){
                return;
            }

            // Stop click events
            if(e.type == 'click'){
                e.preventDefault();
            }

            // Show subnav
            u.addClass(subnav, 'is-active');

            // Deactivate top level nav items and activate this one
            u.removeClass(u.getSiblings(e.target), 'is-active');
            u.addClass(e.target, 'is-active');

            console.log( doc.querySelector('.navigation__category--' + e.target.getAttribute('data-target')) );

            // Swap to the new hovered category
            u.removeClass(categories, 'is-active');
            u.addClass(doc.querySelector('.navigation__category--' + e.target.getAttribute('data-target')), 'is-active');
        }

        function hide(e){
            u.removeClass(subnav, 'is-active');
            u.removeClass(categories, 'is-active');
        }

        navigation.addEventListener('mouseleave', () => {
            // Hide the submav
            u.removeClass(subnav, 'is-active');

            // Deactivate top level link
            if( doc.querySelector('.navigation__top-link.is-active') ){
                u.removeClass(doc.querySelector('.navigation__top-link.is-active'), 'is-active');
            }
        });

        for(const el of doc.querySelectorAll('.navigation__top-link')) {
            el.addEventListener('mouseover', show);
            el.addEventListener('click', show);
        }

        for(const el of doc.querySelectorAll('.navigation__title')) {
            el.addEventListener('click', hide);
        }
    };

    // Display the category thumbnail when mouse over the link in sub nav
    m.menuThumbnails = () => {

        function activate(e){
            if(!e.target.hasAttribute('data-src')){
                return;
            }

            const category = u.closestByClass(e.target, 'navigation__category'),
                image = category.querySelector('.navigation__thumbnail img');

            if(image){
                image.src = e.target.getAttribute('data-src');
            }
        }

        function deactivate(e){
            const category = u.closestByClass(e.target, 'navigation__category'),
                image = category.querySelector('.navigation__thumbnail img');

            if(image){
                image.src = image.getAttribute('data-src');
            }
        }

        for(const el of doc.querySelectorAll('.navigation__link')) {
            el.addEventListener('mouseover', activate);
            el.addEventListener('mouseout', deactivate);
        }
    };

    m.menuToggle = () => {
        const scroll = new SmoothScroll();

        function toggle(){
            u.toggleClass(doc.body, 'nav-open');
            u.removeClass(doc.querySelector('.navigation__category'), 'is-active');

            if(u.hasClass(doc.body, 'nav-open')){
                if(win.innerWidth > 700){
                    scroll.animateScroll(0);
                    setTimeout(() => {
                        noScroll.on();
                    }, 500);
                } else {
                    noScroll.on();
                }
            } else {
                noScroll.off();
            }
        }

        for(const el of doc.querySelectorAll('.js-nav-toggle')) {
            el.addEventListener('click', toggle);
        }
    };

    m.filterToggle = () => {
        const scroll = new SmoothScroll();

        function toggle(){
            u.toggleClass(doc.body, 'filter-open');

            if(u.hasClass(doc.body, 'filter-open')){
                if(win.innerWidth > 700){
                    scroll.animateScroll(0);
                    setTimeout(() => {
                        noScroll.on();
                    }, 500);
                } else {
                    noScroll.on();
                }
            } else {
                noScroll.off();
            }
        }

        for(const el of doc.querySelectorAll('.js-filter-toggle')) {
            el.addEventListener('click', toggle);
        }
    }

    m.related = () => {
        if( !doc.querySelector('.related .products') ){
            return;
        }
        new Flickity(doc.querySelector('.related .products'), {
            prevNextButtons: true,
            pageDots: false,
            wrapAround: true,
            cellAlign: 'left',
            autoPlay: false,
            imagesLoaded: true
        });
    }

    // swap banner imahes
    m.banner = () => {
        const images = doc.querySelectorAll('[data-mobile-src]');

        if( !images ){
            return;
        }

        function myFunction(match) {
            if (match.matches) {
                for(const el of images){
                    el.style.backgroundImage = 'url(' + el.getAttribute('data-mobile-src') + ')';
                }
            } else {
                for(const el of images){
                    el.style.backgroundImage = 'url(' + el.getAttribute('data-src') + ')';
                }
            }
        }

        const match = win.matchMedia("(max-width: 768px)");
        myFunction(match);
        match.addListener(myFunction);
    };

    // Handle notice visibility
    m.Notices = function(){

        function showNotice(notice){
            u.addClass(notice, 'is-visible');
        }

        function hideNotice(notice){
            u.removeClass(notice, 'is-visible');
            Cookies.set(`notice-${notice.getAttribute('data-type')}`, true, { expires: 30 });
        }

        for(const notice of doc.getElementsByClassName('notice--closeable')) {
            if( Cookies.get(`notice-${notice.getAttribute('data-type')}`) === undefined ){
                showNotice(notice);
            }

            notice.querySelector('.notice__close').addEventListener('click', () => { hideNotice(notice); });
        }
    };

    // Scroll to top of pagination click
    m.paginationScroll = () => {
        doc.addEventListener('click', (e) => {
            if( u.hasClass(e.target, 'page-numbers') ) {
                const scroll = new SmoothScroll();
                const anchor = document.querySelector('.woocommerce-category-header-bar');
                scroll.animateScroll(anchor);
            }
        });
    };
};

class Site {

    constructor() {
        // DOM caching
        this.win = window;
        this.doc = document;

        this.doc.documentElement.setAttribute('data-ua',  navigator.userAgent);

        // Globals
        this.ui = {
            fast: 0.2,
            slow: 0.4,
            step: 0.03
        };
        this.modules = {};

        this.init();
    }

    init(){
        moduleRegistration(this.modules, utils, this.ui, this.win, this.doc);

        for (const prop in this.modules) {
            if ( this.modules.hasOwnProperty(prop) ) {
                this.modules[prop]();
            }
        }
    }

}

utils.documentReady(()=>{ new Site(); });
